export * from './src/auth.service';
export * from './src/app-globals';


// WEBPACK FOOTER //
// ./~/angular2-google-login/index.ts